<template>

<!-- Modal -->
<div class="modal" id="modalUpdateCollection" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div style="background-color:cornflowerblue" class="modal-header">
        <h4 class="modal-title" id="staticBackdropLabel">
            <i  class="fas fa-edit mr-2" aria-hidden="true"></i>
           <strong> MODIFICA COLLEZIONE DOCUMENTO </strong></h4>
        <button @click="$emit('close')" type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form id="formMain" v-on:submit.prevent="submit()" >
                
                <div class="form-group">
                <div class="form-group">                
                <collectionSelect v-if="refresh" v-bind:props="collection" @update="setCollectionId"></collectionSelect>                
                <collectionOptionType v-if="refresh" v-bind:typeId="doc.collectionTypeId" @update="setCollectionTypeId"></collectionOptionType>  

                </div>
            
                <label  for="doc_type"><strong>Tipo documento</strong></label>
                <select disabled="true" v-model="doc.typeId" class="form-control bold " id="doc_type">
                    <option value="1">Fattura</option>
                    <option value="2">DDT</option>
                </select>
                </div>
                <div class="form-group">
                  <label for="number_doc"><strong>Numero documento</strong></label>
                  <input disabled="true" v-model="doc.number" type="text" class="form-control bold" placeholder="" name="number_doc" id = "number_doc" >
                </div>
                <div class="form-group">
                  <label for="date_doc"><strong>Data documento</strong></label>
                  <input disabled="true"  v-model="doc.date" type="date" class="form-control bold" placeholder="" name="date_doc" id = "date_doc">
                </div>


                <!--
                <div class="form-group">
                  <label for="number_doc"><strong>Sconto documento</strong></label>
                  <input v-model="doc.discount" type="text" class="form-control bold" placeholder="" name="number_doc" id = "number_doc" required>
                </div>
                -->

        
                <alert-box class="mt-1" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>   
            <button type="submit"  class="btn btn-primary float-right mt-2 mb-2">
              <i class="fas fa-edit mr-2" aria-hidden="true"></i>
              MODIFICA
            <span v-if="spinner"  class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </button>       
      </form>

      
      </div>
      
      
      <div v-if="1==0" class="modal-footer">
       
         
        
           <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal">Chiudi</button>-->
        
      </div>
    </div>
  </div>
</div>


</template>
<script>


import api                     from '@/api';
import alertBox                from '@/components/common/AlertBox.vue';
import collectionSelect        from '@/components/common/CollectionSelect_1.vue' 
import collectionOptionType    from '@/components/backOffice/CollectionOptionType.vue' 



export default {
  
  components: {alertBox,collectionSelect,collectionOptionType
    
  },  
  props: ['documentId'],
 
 data () {
    return {
      


      collection           : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : true,
        

      },


      doc             : {},
      alert           : false,
      spinner         : false,
      refresh         : false,
      
      
     
      msg             : {
          
         title : '',
         body  : '',
         type  : 0
      }
      
      

    }
  },

computed: 
  {
   
   
  },
mounted()
{   
    
   
},
created()
{ 

  this.$nextTick(()  => {                  
    $('#modalUpdateCollection').modal('show')
      this.getData()      
    
    })  

    
},

methods: 
{
    setCollectionId(collectionId)
    {
      this.doc.collectionId = collectionId
    },
    setCollectionTypeId(Id)
    {
      this.doc.collectionTypeId = Id
    },
    
    
    
    async getData()
    {
       
        this.msg.title = ''
        const data = {'documentId' : this.documentId}
        const sp   = {'sp'         : 'spDocumentCollectionHeader'}
        const json = Object.assign(data, sp);
       
        this.spinner = true
        await api.post(json).then(res => {
                   
          if(res.status == 200)
            {
              this.doc           = res.data.recordsets[0][0] 
              this.collection.Id = this.doc.collectionId
              this.refresh       = true
              //this.collections = res.data.recordsets[1]

              //this.refresh++
            }
           else if(res.status == 500)
           {
                                          
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data
              this.msg.type = 1
                    
           } 
           else
            {
                             
              this.msg.title =  'ATTENZIONE '
              this.msg.body = res
              this.msg.type = 1               
                 
            } 
          
          }).catch(err => {
                           
              this.msg.title =  'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type = 1                 
              
          }).finally(() => {
              this.spinner = false
        });


	},
  
   
        
  async submit() 
  {
    this.msg.title = ''
    this.spinner = true
    const data  = {'stockMovementId':this.doc.stockMovementId,'collectionId':this.doc.collectionId,'typeId':this.doc.collectionTypeId}       
    const sp    = {'sp':'spUpdateStockMovementCollection'}
    const json  = Object.assign(data, sp);

    await api.post(json).then(res => {
          
          if(res.status == 200)
            {
                this.msg.title = 'COLLEZIONE MODIFICATA.'
                this.msg.body = ''
                this.msg.type = 0
                console.log('UPDATE COLLECTION')
              
            }
           else if(res.status==500)
           {
                          
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data
              this.msg.type = 1                
                    
           } 
           else
            {
                           
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res
              this.msg.type = 1 
            } 
          
          }).catch(err => {
                           
              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type = 1 
              
          }).finally(() => {
          this.spinner = false
        });



	}
  
      
}
    
}    
</script>

<style scoped>

 .form-check-label
 {
  cursor: pointer;
 }
.bold {
  font-weight: bolder;
}

h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
.modal-content {
  -webkit-border-radius: 0px !important;
  -moz-border-radius: 0px !important;
  border-radius: 15px !important;
  -webkit-border: 0px !important;
  -moz-border: 15px !important;
  border: 0px !important;
}


</style>